import FilterPage from '@/components/filterpage/FilterPage.vue'
import { CURRENTCOMPONTENT } from '@/composables/helpers'
import type { IAccosApiResponse } from '@/composables/interfaces/apiInterfaces'
import type { IFiltersDataInterface, IFilterStoreInterface } from '@/composables/interfaces/appInterfaces'
import { FilterPageUrl, FilterStoreQueryString, PetsAllowedAmenityId } from '@/constants'
import { watchIgnorable } from '@vueuse/core'
import { ref, watch, type Ref } from 'vue'
import { pets } from './accosbar.store'

//TODO: get ratings already in correct format from the backend?
export const ratingsFilterSelected: Ref<number[]> = ref([])
export const filterCount = ref(0)
export const searchedAreaId = ref()
export const filtersData = ref<IFiltersDataInterface | null>(null)
export const accosApiResults = ref<IAccosApiResponse | null>(null)

export const filterStore = ref<IFilterStoreInterface>({
  areaId: 0,
  startDate: null,
  endDate: null,
  rooms: null,
  accotypeIds: [],
  themeId: 0,
  amenityIds: [],
  boardingIds: [],
  ratingFrom: 0,
  ratingTo: 5.5,
  companyIds: []
})

export function fillFilterStoreFromUrlState(): void {
  const urlParams = new URLSearchParams(window.location.search)
  const filterStoreFromQueryParams = urlParams.get(FilterStoreQueryString)
  if (filterStoreFromQueryParams != null) {
    const x = atob(filterStoreFromQueryParams)
    //prevents that same state is pushed to the url and a new history entry is made
    if (x != JSON.stringify(filterStore.value)) {
      const data = JSON.parse(x) as IFilterStoreInterface
      filterStore.value = data
    }
  }
}

watch(
  filterStore,
  () => {
    const url = new URL(window.location.toString())
    if (url.pathname == FilterPageUrl && CURRENTCOMPONTENT == FilterPage) {
      const data = btoa(
        JSON.stringify({
          ...filterStore.value,
          accotypes: filterStore.value.accotypeIds.map((item) => {
            return {
              id: item,
              ratingFrom: filterStore.value.ratingFrom,
              ratingTo: filterStore.value.ratingTo
            }
          })
        })
      )
      if (url.searchParams.get(FilterStoreQueryString) != null && url.searchParams != null) {
        url.searchParams.set(FilterStoreQueryString, data)
      } else {
        url.searchParams.append(FilterStoreQueryString, data)
      }
      window.history.replaceState({}, '', url)
    }
  },
  { deep: true } //ensures that the watcher reacts to changes in nested properties inside objects or arrays.
)

const watchRatingsFilterSelected = watchIgnorable(ratingsFilterSelected, (r, oldR) => {
  if (oldR.length > r.length && oldR[0] === r[0] && oldR[oldR.length - 1] === r[r.length - 1]) {
    r = oldR.filter((x) => !r.includes(x))
  }
  const max = r && r.length ? Math.max(...r) : 5.5
  const min = r && r.length ? Math.min(...r) : 0
  filterStore.value.ratingFrom = min
  filterStore.value.ratingTo = max === 4 ? 4.5 : max === 3 ? 3.5 : max

  watchRatingsFilterSelected.ignoreUpdates(() => {
    ratingsFilterSelected.value = r && r.length ? Array.from({ length: max - min + 1 }, (v, i) => min + i) : []
  })
})

export const ratingsFilterSelectedIgnoreUpdates = watchRatingsFilterSelected.ignoreUpdates

ratingsFilterSelectedIgnoreUpdates(() => {
  if (filterStore.value.ratingFrom && filterStore.value.ratingTo) {
    ratingsFilterSelectedIgnoreUpdates(() => {
      ratingsFilterSelected.value = Array.from(
        { length: filterStore.value.ratingTo - filterStore.value.ratingFrom + 1 },
        (v, i) => filterStore.value.ratingFrom + i
      )
    })
  }
})

function calcRatingSelectedFromFilter(filter: IFilterStoreInterface): number[] {
  return filterStore.value.ratingTo && filterStore.value.ratingFrom
    ? Array.from({ length: filterStore.value.ratingTo - filterStore.value.ratingFrom + 1 }, (v, i) => filterStore.value.ratingFrom + i)
    : []
}

function getFilterCount(filter: IFilterStoreInterface): void {
  let count = 0

  const rating = calcRatingSelectedFromFilter(filter)

  if (filter.themeId) count++
  if (rating) count += rating.length
  if (filter.accotypeIds) count += filter.accotypeIds.length
  if (filter.boardingIds) count += filter.boardingIds.length
  if (filter.amenityIds) count += filter.amenityIds.length

  filterCount.value = count
}

watch(
  () => filterStore,
  (filter) => {
    if (filter.value) {
      getFilterCount(filter.value)
    }
  },
  { deep: true }
)

watch(
  //done to keep pets.value.hasPets and filterStore.value.amenityIds in sync
  () => filterStore.value.amenityIds,
  () => {
    if (filterStore.value.amenityIds.includes(PetsAllowedAmenityId)) {
      pets.value.hasPets = true
    } else {
      pets.value.hasPets = false
    }
  }
)
